import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Inject,
} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Link} from '../../../../shared/link/link';
import {Messages} from '../../../../messages.enum';

@Component({
    selector: 'link-created-message',
    templateUrl: './link-created-message.component.html',
    styleUrls: ['./link-created-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkCreatedMessageComponent {
    message = this.data.createMsg || Messages.LINK_CREATE_SUCCESS;
    constructor(
        @Inject(MAT_SNACK_BAR_DATA)
        public data: {link: Link; createMsg?: string}
    ) {}
}
